export default function StatsSection() {
  const stats = [
    { icon: 'ri-user-3-line', value: '500万+', label: '累计用户' },
    { icon: 'ri-file-list-3-line', value: '1.2亿+', label: '累计订单' },
    { icon: 'ri-money-cny-circle-line', value: '89亿+', label: '累计兑奖' },
    { icon: 'ri-star-line', value: '4.9', label: '用户评分' },
  ];

  return (
    <section className="w-full px-4 md:px-6 -mt-16 relative z-20">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl p-5 md:p-6 text-center border border-background-200/70"
            >
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-lg bg-primary-100">
                <i className={`${stat.icon} text-lg text-primary-600`}></i>
              </div>
              <div className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
                {stat.value}
              </div>
              <div className="text-foreground-500 text-xs mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}